import * as React from 'react';
import { IndexRedirect, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import TeamsApp from 'bundles/teams-v2/components/TeamsApp';

const AccountDetails = loadOnRoute(() => import('bundles/teams-v2/components/AccountDetails'));
const AccountDetailsVerify = loadOnRoute(() => import('bundles/teams-v2/components/AccountDetailsVerify'));
const BillingInfo = loadOnRoute(() => import('bundles/teams-v2/components/BillingInfo'));
const EnterpriseLeadUnsubscribe = loadOnRoute(() => import('bundles/teams-v2/components/EnterpriseLeadUnsubscribe'));
const FreeTrialConfirmation = loadOnRoute(() => import('bundles/teams-v2/components/FreeTrialConfirmation'));
const PlanDetails = loadOnRoute(() => import('bundles/teams-v2/components/PlanDetails'));
const PurchaseConfirmation = loadOnRoute(() => import('bundles/teams-v2/components/PurchaseConfirmation'));

export default (
  <Route path="/">
    <Route path="enterprise-unsubscribe" getComponent={EnterpriseLeadUnsubscribe} />
    <Route path="purchase" component={TeamsApp}>
      <Route path="plan" getComponent={PlanDetails} />
      <Route path="account" getComponent={AccountDetails} />
      <Route path="verify" getComponent={AccountDetailsVerify} />
      <Route path="billing" getComponent={BillingInfo} />
      <Route path="confirmation" getComponent={PurchaseConfirmation} />
      <Route path="freetrial-confirmation" getComponent={FreeTrialConfirmation} />
      <Route path="*" component={NotFound} />
      <IndexRedirect to="/purchase/plan" />
    </Route>
  </Route>
);
